import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ProgressService {
    public isComplete: boolean = false;
}
